import { useTranslation } from "react-i18next";

import { QrCode } from "@/components/QrCode";
import { isReceiptLink } from "@/lib/receipts";

/**
 * The receipt's QR on screen (T07-42): the digital receipt link (T10-34 `/r/<receiptNo>?t=…`)
 * says 「電子レシート」 — the customer opens the receipt on the phone without signing in; a bare
 * receipt number (no link configured) says what it is instead.
 */
export function ReceiptQr({ value, size }: { value: string; size?: number }) {
  const { t } = useTranslation();
  const link = isReceiptLink(value);
  return (
    <figure className="flex flex-col items-center gap-2 text-center" data-testid="receipt-qr">
      {link ? <p className="text-lg font-semibold">{t("receipt.e_receipt")}</p> : null}
      <QrCode
        value={value}
        label={link ? t("receipt.e_receipt") : t("receipt.qr_number")}
        {...(size ? { size } : {})}
      />
      <figcaption className="max-w-72">
        {t("receipt.qr_title")}
        {link ? (
          <span className="block text-sm text-muted-foreground">{t("receipt.e_receipt_help")}</span>
        ) : null}
      </figcaption>
    </figure>
  );
}
